import { Button, Stack } from "@mui/material";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as z from "zod";

import { useCreateNotificationHandlerNotificationHandlersPostMutation } from "api";
import { TextInput } from "components/forms";
import { INotificationHandlerNetNordic } from "interfaces/notification.interface";

const netNordicHandlerSchema = z.object({
  description: z.string(),
  configuration: z.object({
    client_id: z.string().optional(),
    username: z.string(),
    password: z.string(),
    api_base_url: z.url(),
  }),
});

type NetNordicHandlerSchema = z.infer<typeof netNordicHandlerSchema>;

type TempNetNordicProps = {
  disabled: boolean;
  zoneId: string;
  onClose: () => void;
  defaultValues: INotificationHandlerNetNordic | null;
};

export function TempNetNordic({
  disabled,
  zoneId,
  onClose,
  defaultValues,
}: TempNetNordicProps) {
  const { t } = useTranslation();

  const [createHandler] =
    useCreateNotificationHandlerNotificationHandlersPostMutation();

  const { control, handleSubmit } = useForm<NetNordicHandlerSchema>({
    resolver: zodResolver(netNordicHandlerSchema),
    defaultValues: defaultValues ?? {},
  });

  const onCreate = async (data: NetNordicHandlerSchema) => {
    await createHandler({
      notificationHandlerCreate: {
        type: "netnordic",
        zone_id: zoneId,
        enabled: true,
        ...data,
      },
    });

    onClose();
  };

  return (
    <Stack
      component={"form"}
      onSubmit={handleSubmit(onCreate)}
      sx={{
        gap: 1,
      }}
    >
      <TextInput
        fieldName={"description"}
        control={control}
        label={t("Description")}
        placeholder={t(
          "notification_netnordic_handler_description_placeholder",
        )}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.client_id"}
        control={control}
        label={t("Client ID")}
        placeholder={t("notification_netnordic_handler_client_id_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.username"}
        control={control}
        label={t("login_name")}
        placeholder={t("notification_netnordic_handler_username_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.password"}
        control={control}
        label={t("Password")}
        placeholder={t("notification_netnordic_handler_password_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.api_base_url"}
        control={control}
        label={t("notification_handler_net_nordic_base_url")}
        placeholder={t(
          "notification_netnordic_handler_api_base_url_place_holder",
        )}
        disabled={disabled}
        required
      />
      <Stack
        direction={"row"}
        sx={{
          gap: 2,
        }}
      >
        {!defaultValues && <Button type={"submit"}>{t("Create")}</Button>}
        <Button variant={"text"} onClick={onClose}>
          {t("Cancel")}
        </Button>
      </Stack>
    </Stack>
  );
}
